import { createFileRoute } from '@tanstack/react-router';

import { getSamplingQueries, SamplingPlansPage } from '@sampling';

export const Route = createFileRoute('/_app/_admin/sampling-plans')({
  loader: async ({ context }) => {
    const queries = getSamplingQueries();
    await context.queryClient.prefetchQuery(
      queries.plans.list({
        page: 1,
        sorting: [],
        filters: [],
      }),
    );
  },
  component: SamplingPlansPage,
});
